<div class="float-drag" cdkDrag>
	<div class="float-container" cdkDragHandle>
        <div class="float-header" >
			<div class="header-text">A3I Street Name Parsing Wizard</div>
			<i class="glyphicons glyphicons-remove" (click)="close()"></i>
        </div>
	
		<div class="wizard-content-wrap-columns">
			<div class="wizard-step-container">
				<ng-container *ngFor="let step of steps">
					<div *ngIf="step.num <= currentStep.num" class="same-line wizard-step-sameline" [@fadeInOut]>
						<app-wizard-step-title [stepNum]="step.num" [stepLabel]="step.label" [isCurrent]="step.num===currentStep.num"></app-wizard-step-title>
						<div *ngIf="step.num===1">
							<select name="parsingDirection" [(ngModel)]="parsingDirection">
								<option value="legacyToNena">Legacy to NENA</option>
								<option value="nenaToLegacy">NENA to Legacy</option>
							</select>
						</div>
						<div *ngIf="step.num===2">
							<input type="checkbox" name="isExtendEntireStreet" [(ngModel)]="isExtendEntireStreet">
						</div>
					</div>
				</ng-container>
			</div>
	
			<div class="wizard-button-groups">
				<div style="flex-grow:1;margin-bottom: 10px;">
					<button class="button-general button-small" (click)="cancel()">Cancel</button>
				</div>
				<button disabled="{{currentStep.isFirst}}" class="button-general button-small" (click)="goPrev()">Prev</button>
				<button class="button-general button-small" [disabled]="checkGoNextDisabled(currentStep.prop)" (click)="goNext()">{{currentStep.isLast ? 'Parse' :  'Next'}}</button>
			</div>
		</div>
	</div>
</div>